// extracted by mini-css-extract-plugin
export default {"link":"link--BGs3t","link__body":"link__body--Wjh_F"};